import React, { useState, useCallback, useRef, useEffect, useLayoutEffect } from 'react'
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"
import Avatar from '../shared/avatar.component';
import { Autocomplete, Checkbox, InputAdornment, TextField } from '@mui/material';
import ButtonComponent from '../shared/button/button.component';
import { buttonLabels } from '../shared/constants';
import { WebFormService } from '../../services/WebFormService';
import { mapToWebFormModel, WebFormModel, WebFormStatus } from '../../models/web-form.model';
import { CustomAttributeDefinitionModel, CustomAttributeType } from '../../models/custom-attribute.model';
import { DisabledGridIcon, DraftIcon, FalconLogo, LockGrayIcon, MailIcon, PausedIcon, PlansGridIcon, RemoveAlertIcon, ReportsScheduledGridIcon, SuccessWhiteIcon } from '../../icon';
import DateAndTimePicker from '../shared/datetimepicker/date-timepicker.component';
import { validateForm } from '../shared/form-validation';
import UnAuthComponent from '../layout/unauth.component';
import AnimateLoader from "../shared/loaders/animate-loader.component";
import WebFormInitialLoader from "../shared/loaders/web-form-open-initial-loader.json";
import WebFormMobileInitialLoader from "../shared/loaders/web-form-open-initial-mobile-loader.json";
import { UtilityService } from '../../services/UtilityService';


const boolenOptions = [{ id: "false", label: "false" }, { id: "true", label: "true" }]
const Fileds: CustomAttributeDefinitionModel[] = [
    { Id: 'FirstName', Name: 'First Name', IsRequired: true, Reference: '', Type: 0 },
    { Id: 'LastName', Name: 'Last Name', IsRequired: false, Reference: '', Type: 0 },
    { Id: 'PhoneNumber', Name: 'Phone Number', IsRequired: true, Reference: '', Type: CustomAttributeType.Phone },
    { Id: 'Email', Name: 'Email Address', IsRequired: false, Reference: '', Type: CustomAttributeType.Email },
];
const EndUserWebFormComponent = () => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const calnderRef = useRef(null);

    const [formId, setFormId] = useState<string>("");
    const [webFormData, setWebFormData] = useState<WebFormModel>(null);
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [selectedFields, setSelectedFields] = useState<CustomAttributeDefinitionModel[]>(Fileds)
    const [customValues, setCustomValues] = useState<{ [key: string]: any }>({});
    const [customAttributesErrors, setCustomAttributesErrors] = useState<{ [key: string]: any }>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [fileStatusError, setFileStatusError] = useState<string>("")
    const [isRunningInIframe, setIsRunningInIframe] = useState<boolean>(window.self !== window.top)
    const [contactDetails, setContactDetails] = useState<{ FirstName: string, LastName: string, Email: string, PhoneNumber: string, }>({ FirstName: "", LastName: "", Email: "", PhoneNumber: "", })

    const [errors, setErrors] = useState<{ FirstName: string, LastName: string, Email: string, PhoneNumber: string, }>({
        FirstName: "", LastName: "", Email: "", PhoneNumber: "",
    })

    useLayoutEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const formId = queryParams.get('formId');
        setFormId(formId);
        if (!webFormData) {
            WebFormService.getEndUserWebFormByid(formId).then((res) => {
                const data = mapToWebFormModel(res.data, true);
                setWebFormData(data);
                const fields = [...Fileds, ...data.CustomContactAttributes]
                const orderListFields = data?.FieldIdsOrder.map(id => fields.find(item => item.Id?.toLowerCase() === id.toLowerCase())).filter(Boolean);
                setSelectedFields(orderListFields);
            }).catch((error) => {
                console.error("Error fetching web form data:", error);
                setFileStatusError(error.response?.data?.message || "Error fetching web form data");
            });
        }
    }, [])

    const handleChange = (name: any, value: any,) => {
        setContactDetails({ ...contactDetails, [name]: value });
        validateForm({ [name]: value }, (Errors) => {
            console.log("hii");

            setErrors({ ...errors, ...Errors });
        });
    }

    const handleCustomAttributeChange = (data: CustomAttributeDefinitionModel, value: any) => {
        if (!data.Reference) {
            handleChange(data.Id, value);
        } else {
            setCustomValues(prev => ({
                ...prev, [data.Id]: value
            }));
            setCustomAttributesErrors(prv => ({
                ...prv, [data.Id]: !!value?.length ? "" : data.IsRequired ? `${data.Name} cannot be blank.` : ""
            }))
        }
    };

    const validateCustomAttributes = () => {
        const next: Record<string, string> = {};
        webFormData.CustomContactAttributes.forEach((x) => {
            if (x.IsRequired) {
                const val = (customValues[x.Id] ?? "").trim();
                if (!val) next[x.Id] = `${x.Name} cannot be blank.`;
            }
        });
        setCustomAttributesErrors(next);
        return Object.keys(next).length === 0;
    };


    const onSubmit = () => {

        const standardValid = validateForm(
            { FirstName: contactDetails.FirstName, PhoneNumber: contactDetails.PhoneNumber, contactlastname: contactDetails.LastName, contactemail: contactDetails.Email },
            (Errors) => setErrors((prev) => ({ ...prev, ...Errors }))
        );
        const customValid = validateCustomAttributes();
        if (!standardValid || !customValid) {
            return;
        }
        setIsLoading(true);
        const payload = {
            FirstName: contactDetails.FirstName,
            PhoneNumber: UtilityService.unmaskPhoneNumber(contactDetails.PhoneNumber),
            Lastname: contactDetails.LastName,
            Email: contactDetails.Email,
            customAttributes: webFormData.CustomContactAttributes
                .map((x) => ({
                    id: x.Id,
                    reference: x.Reference,
                    name: x.Name,
                    value: (customValues[x.Id] || "").trim(),
                    type: x.Type,
                })).filter((x) => x.value),
        };

        WebFormService.createContact(formId, payload).then((res) => {
            setIsSubmitted(true);
        }).catch((error) => {
            console.error("Error creating contact:", error);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    return (<div className={'web-form-bg'}>
        {(!webFormData && !fileStatusError) ?
            <div className={`w-p-100 h-v-100 d-flex align-center justify-center`}>
                {IsMobileDevice ? <AnimateLoader LoaderAnimation={WebFormMobileInitialLoader} /> : <AnimateLoader LoaderAnimation={WebFormInitialLoader} className='w-p-60' />
                }
            </div> :
            (webFormData?.Status === WebFormStatus.Deleted || !!fileStatusError) ?
                <div className='w-p-100 h-v-100 d-flex align-center justify-center'>
                    <div className={`${IsMobileDevice ? "w-p-85 h-p-55" : isRunningInIframe ? "w-p-70 h-p-50" : "w-p-30 h-p-50"} my-auto br-3 border-primary-divider  d-flex align-center justify-between flex-direction bg-color-secondary tooltip-z-index`}>
                        <div className='d-flex flex-direction align-center justify-center h-p-92 bb-primary-divider-1'>
                            <RemoveAlertIcon className='w-8 h-8 mb-1' />
                            <div className='h-3 border-primary-divider br-2 px-1 bg-color-photosensitivity-warning'>
                                <DisabledGridIcon />
                                <span className='color-primary-danger h4-regular ml-1'>Removed</span>
                            </div>
                            <span className='mt-3 h2-semibold color-primary-accent'>{!!fileStatusError ? fileStatusError : "This form is no longer available"}</span>
                            <div className='mt-1 h4-regular color-primary-accent t-align-center px-2'>The link may be broken, or this form has been removed by its owner. Double-check the link you were given.</div>
                        </div>
                        <div className='d-flex align-center justify-center'>
                            <span className='h5-regular d-flex align-center justify-center'>
                                <span className='color-text-field-label'>Powered by</span>
                                <a href="https://www.falkonsms.com/" target="_blank" className='d-flex align-center' style={{ textDecoration: "none" }}>
                                    <FalconLogo className='w-18 ml-1' />
                                </a>
                            </span>
                        </div>
                    </div>
                </div> :
                webFormData.Status === WebFormStatus.Draft ?
                    <div className='w-p-100 h-v-100 d-flex align-center justify-center'>
                        <div className={`${IsMobileDevice ? "w-p-85 h-p-60" : isRunningInIframe ? "w-p-70 h-p-50" : "w-p-30 h-p-50"} my-auto br-3 border-primary-divider  d-flex align-center justify-between flex-direction bg-color-secondary tooltip-z-index`}>
                            <div className='d-flex flex-direction align-center justify-center h-p-92 bb-primary-divider-1'>
                                <div className='d-flex align-center border-primary-divider p-1 br-3 my-1'>
                                    <Avatar Size={25} Name={webFormData.Title} ImgSrc={webFormData?.Logo?.Url} />
                                    <span className='h4-regular ml-1'> {webFormData.Title}</span>
                                </div>
                                <DraftIcon className='w-8 h-8 mb-2 my-1' />
                                <div className='h-3 border-primary-divider br-2 px-1 bg-color-consent-message-bg'>
                                    <PlansGridIcon />
                                    <span className='color-primary-light h4-medium ml-1'>DRAFT</span>
                                </div>
                                <span className='mt-3 h2-semibold color-primary-accent'>{"This form isn't live yet"}</span>
                                <div className='mt-1 h4-regular color-primary-accent t-align-center px-2'>The sign-up form you're looking for hasn't been published. Please check back soon.</div>
                            </div>
                            <div className='d-flex align-center justify-center'>
                                <span className='h5-regular d-flex align-center justify-center'>
                                    <span className='color-text-field-label'>Powered by</span>
                                    <a href="https://www.falkonsms.com/" target="_blank" className='d-flex align-center' style={{ textDecoration: "none" }}>
                                        <FalconLogo className='w-18 ml-1' />
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div> :
                    webFormData.Status === WebFormStatus.Paused ?
                        <div className='w-p-100 h-v-100 d-flex align-center justify-center'>
                            <div className={`${IsMobileDevice ? "w-p-85 h-p-60" : isRunningInIframe ? "w-p-70 h-p-50" : "w-p-30 h-p-50"} my-auto br-3 border-primary-divider  d-flex align-center justify-between flex-direction bg-color-secondary tooltip-z-index`}>
                                <div className='d-flex flex-direction align-center justify-center h-p-92 bb-primary-divider-1'>
                                    <div className='d-flex align-center border-primary-divider p-1 br-3 my-1'>
                                        <Avatar Size={25} Name={webFormData.Title} ImgSrc={webFormData?.Logo?.Url} />
                                        <span className='h4-regular ml-1'> {webFormData.Title}</span>
                                    </div>
                                    <PausedIcon className='w-10 h-10 mb-1' />
                                    <div className='h-3 border-primary-divider br-2 px-1 bg-color-web-form-paused-bg'>
                                        <ReportsScheduledGridIcon />
                                        <span className='color-primary-warning h4-medium ml-1'>PAUSED</span>
                                    </div>
                                    <span className='mt-3 h2-semibold color-primary-accent'>{"Sign-ups are paused"}</span>
                                    <div className='mt-1 h4-regular color-primary-accent t-align-center px-2'>{`${webFormData?.Title} isn't accepting new sign-ups right now. Please check back a little later.`}</div>
                                </div>
                                <div className='d-flex align-center justify-center'>
                                    <span className='h5-regular d-flex align-center justify-center'>
                                        <span className='color-text-field-label'>Powered by</span>
                                        <a href="https://www.falkonsms.com/" target="_blank" className='d-flex align-center' style={{ textDecoration: "none" }}>
                                            <FalconLogo className='w-18 ml-1' />
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div> :
                        isSubmitted ?
                            <div className='w-p-100 h-v-100 d-flex align-center justify-center'>
                                <div className={`${IsMobileDevice ? "w-p-85 h-p-65" : isRunningInIframe ? "w-p-70 h-p-55" : "w-p-30 h-p-55"} my-auto br-3 border-primary-divider  d-flex align-center justify-between flex-direction bg-color-secondary tooltip-z-index`}>
                                    <div className='d-flex flex-direction align-center justify-center h-p-92 bb-primary-divider-1'>
                                        <div className='d-flex align-center border-primary-divider p-1 br-3 my-1'>
                                            <Avatar Size={25} Name={webFormData.Title} ImgSrc={webFormData?.Logo?.Url} />
                                            <span className='h4-regular ml-1'> {webFormData.Title}</span>
                                        </div>
                                        <SuccessWhiteIcon className='w-12 h-12' />

                                        <span className='mt-3 h2-semibold color-primary-accent'>You're all set</span>
                                        <div className='mt-1 h5-medium color-primary-accent t-align-center px-2'>{`Thanks for signing up with ${webFormData?.Title}. Your details have been received — keep an eye on your phone for a confirmation message.`}</div>
                                        {/* <span className='p-1 my-2 border-primary-divider color-primary-accent h4-medium br-2'>Done</span> */}
                                    </div>
                                    <div className='d-flex align-center justify-center'>
                                        <span className='h5-regular d-flex align-center justify-center'>
                                            <span className='color-text-field-label'>Powered by</span>
                                            <a href="https://www.falkonsms.com/" target="_blank" className='d-flex align-center' style={{ textDecoration: "none" }}>
                                                <FalconLogo className='w-18 ml-1' />
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div> :
                            <div className={`w-p-100 h-v-100 d-flex justify-center tooltip-z-index ${IsMobileDevice ? "" : "align-center"}`} >
                                <div className={`${IsMobileDevice ? `w-p-85 ${isRunningInIframe ? "max-fit-h-v-98" : "max-fit-h-v-85"} mt-2 border-primary-divider` : isRunningInIframe ? "w-p-80 max-fit-h-v-90" : "w-p-30 max-fit-h-v-96 border-primary-divider"} pt-2 br-3  bg-color-secondary d-flex flex-direction o-y-scroll`}>
                                    <div className='w-p-90 mx-auto d-flex flex-direction'>
                                        <div className='d-flex align-center justify-center'>
                                            <Avatar Size={40} Index={1} Name={webFormData?.Title} ImgSrc={webFormData.Logo.Url} />
                                        </div>

                                        <div className='t-align-center color-primary-accent h2-medium'>{webFormData?.Title}</div>
                                        <div className='h5-regular h-p-5 d-flex align-center my-auto justify-center w-break'>{webFormData?.Description}</div>
                                        <div className={`d-flex flex-direction  o-y-auto mx-auto br-2 py-1 w-p-100 ${IsMobileDevice ? "max-fit-h-v-38" : isRunningInIframe ? "max-fit-h-v-40" : "max-fit-h-v-45"}`}>
                                            <div className='w-p-95 mx-auto'>
                                                <div>
                                                    {selectedFields.map(x => {
                                                        return (
                                                            <div key={x.Id}>
                                                                <div className='h5-regular mt-1'>
                                                                    {x.Name}{x.IsRequired && " *"}
                                                                </div>

                                                                {(x.Type === CustomAttributeType.Boolen || x.Type === CustomAttributeType.Dropdown) ?
                                                                    <Autocomplete
                                                                        size='small'
                                                                        renderInput={(params) => <TextField {...params} placeholder={x.Description} />}
                                                                        options={x.Type === CustomAttributeType.Boolen ? boolenOptions : x.OptionsDetail}
                                                                        getOptionLabel={(option) => option.label}
                                                                        disableClearable
                                                                        onChange={(event, value) => handleCustomAttributeChange(x, value?.id)}
                                                                        value={customValues[x.Id]}
                                                                    />
                                                                    :
                                                                    x.Type === CustomAttributeType.Date ?
                                                                        <div ref={calnderRef}>
                                                                            <DateAndTimePicker
                                                                                // TextLabel={x.Name}
                                                                                DateTime={customValues[x.Id] ? new Date(customValues[x.Id]).getTime() : -1}
                                                                                HideTime={true}
                                                                                FormatTextLabel={x.Description}
                                                                                FormatText="MMMM Do YYYY"
                                                                                ShowMinData={true}
                                                                                handleChange={(ts: number) => {
                                                                                    const date = new Date(ts).toISOString().slice(0, 10);
                                                                                    handleCustomAttributeChange(x, date);
                                                                                }}
                                                                            />
                                                                        </div> :
                                                                        <TextField
                                                                            size='small'
                                                                            className='w-p-100'
                                                                            value={!x.Reference ? contactDetails[x.Id] : customValues[x.Id] || ""}
                                                                            onChange={(e) => {
                                                                                if (x.Type === CustomAttributeType.Phone && /\D/.test(e.target.value)) {
                                                                                    return;
                                                                                }
                                                                                handleCustomAttributeChange(x, e.target.value)
                                                                            }
                                                                            }
                                                                            label={(x.Type === CustomAttributeType.Boolen || x.Type === CustomAttributeType.Dropdown) ? x.Description : ""}
                                                                            select={x.Type === CustomAttributeType.Boolen || x.Type === CustomAttributeType.Dropdown}
                                                                            placeholder={x.Description}
                                                                            InputProps={{
                                                                                endAdornment: x.Type === CustomAttributeType.Email && (
                                                                                    <InputAdornment position="start">
                                                                                        <MailIcon />
                                                                                    </InputAdornment>
                                                                                )
                                                                            }}
                                                                        />
                                                                }
                                                                <div className='color-primary-danger h6-regular float-right'>{!x.Reference ? errors[x.Id] : customAttributesErrors[x.Id]}</div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`d-flex py-1 ${IsMobileDevice ? "h-p-20 min-h-11" : "h-p-15"} h6-regular`}>
                                            <Checkbox
                                                checked={isChecked}
                                                onChange={(e) => setIsChecked(e.target.checked)}
                                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                            />
                                            <div className='h-p-100 d-flex align-center my-auto'>
                                                <div>
                                                    I agree to receive recurring automated text messages from {webFormData.Title} at the phone number provided. Consent is not a condition of purchase. Message & data rates may apply. Message frequency varies. Reply STOP to unsubscribe or HELP for help.

                                                    {(webFormData.PrivacyPolicyUrl || webFormData.TermsConditionUrl) && <> See our </>}

                                                    {webFormData.PrivacyPolicyUrl && (
                                                        <a href={webFormData.PrivacyPolicyUrl}
                                                            target="_blank"
                                                            style={{ color: "#3663ff", textDecoration: "none" }}
                                                        >
                                                            Privacy Policy
                                                        </a>
                                                    )}

                                                    {webFormData.PrivacyPolicyUrl && webFormData.TermsConditionUrl && <> and </>}

                                                    {webFormData.TermsConditionUrl && (
                                                        <a href={webFormData.TermsConditionUrl}
                                                            target="_blank"
                                                            style={{ color: "#3663ff", textDecoration: "none" }}
                                                        >
                                                            Terms of Service
                                                        </a>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <ButtonComponent
                                            ButtonLabel={webFormData.ButtonLabel ?? buttonLabels.SUBMIT}
                                            Variant={isChecked ? 'primary-btn-small' : 'disabled-btn-small'} ClassName='w-p-100'
                                            OnClick={onSubmit} Loading={isLoading}
                                        />

                                        <div className='h5-regular color-text-field-label py-1 bb-primary-divider-1 d-flex align-center justify-center'>
                                            <LockGrayIcon />
                                            <div className='ml-1'>Your information is secure</div>
                                        </div>
                                        <div className='d-flex align-center justify-center h-p-10'>
                                            <span className='h5-regular d-flex align-center justify-center'>
                                                <span className='color-text-field-label'>Powered by</span>
                                                <a href="https://www.falkonsms.com/" target="_blank" className='d-flex align-center' style={{ textDecoration: "none" }}>
                                                    <FalconLogo className='w-18 ml-1' />
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
        }
    </div>
    )
}
export default EndUserWebFormComponent;
